export default __webpack_public_path__ + "static/media/RAPPORT GENERAL ANNUEL DES ACTIVITES 2025.447eaa61.pdf";